module.exports = __webpack_public_path__ + "img/artboard11.2468d0b1.png";